import { filter } from "@/assets";
import { DataTable, Heading } from "@/components";
import { Button, Card } from "@/components/ui";
import useSchool from "./useSchool";
import { Filter } from "./Filter";

const School = () => {
  const {
    columns,
    onAdd,
    onCancelFilter,
    onFilterBtnClick,
    openFilter,
    filterData,
    setFilterData,
    tableData,
    isPending,
    isError,
    pageNumber,
    pageSize,
    totalPages,
    totalRecords,
    setPageNumber,
    setPageSize,
  } = useSchool();

  return (
    <div className="p-7">
      <Heading title="Onboarded School" />

      <Card className="py-5 pt-0 mt-6 shadow-none">
        <div className="mt-5 px-5 flex justify-end gap-3">
          <Button type="button" variant="ghost" onClick={onFilterBtnClick}>
            <img src={filter} />
            Filter
          </Button>
          {/* <Button onClick={onAdd}>+ Add New</Button> */}
        </div>
        {isPending && <div className="px-5 py-3">Loading...</div>}
        {!isPending && !isError && (
          <DataTable
            columns={columns}
            data={tableData}
            serviceSidePagination
            pageNumber={pageNumber}
            pageSize={pageSize}
            totalPages={totalPages}
            totalRecords={totalRecords}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
          />
        )}
      </Card>
      {openFilter && (
        <Filter
          onCancel={onCancelFilter}
          filterData={filterData}
          setFilterData={setFilterData}
        />
      )}
    </div>
  );
};

export default School;
